import React, { useEffect, useCallback } from 'react'
import { navigate } from '@reach/router'
import Vault from 'lib/Vault'
import SessionManagerService from './Service'
import { ISessionManagerProviderProps } from './Interfaces'
import { useServiceState, useNotification } from 'helpers'

const Provider: React.FC<ISessionManagerProviderProps> = ({ children }) => {
  const state = useServiceState(SessionManagerService, false)
  const { emitError } = useNotification()

  useEffect(() => {
    if (!window.location.href.includes('callback')) {
      if (!state.callbackUrl) {
        Vault.clearAccessToken()
        SessionManagerService.setCallbackUrl()
      }
    } else {
      SessionManagerService.setCallbackUrl()
    }
  }, [window.location.href])

  const onWhoAmIError = useCallback(
    (error: string) => {
      emitError(error)
      navigate('/')
    },
    [emitError]
  )

  useEffect(() => {
    async function loadAsync() {
      try {
        if (Vault.getAccessToken()) {
          await SessionManagerService.whoAmI()
        }
      } catch (error) {
        onWhoAmIError(error.message)
      } finally {
        SessionManagerService.setIsMounted(true)
      }
    }
    loadAsync()
  }, [onWhoAmIError])

  return <React.Fragment>{children({ state })}</React.Fragment>
}

export default Provider
